import React, { useState } from "react";
import {
  IonButton,
  IonCardContent,
  IonCol,
  IonGrid,
  IonRow,
  IonImg,
  IonIcon,
} from "@ionic/react";
import { ShipmentDetails } from "../../../../components/shipment-details/shipmentDetails";
import { LoadTileMiddle } from "../../../../components/load-tile";
import { calculateTime, isWatched } from "../utils";
import { TopRecommTileProps } from "../types";
import { IONICWrapper } from "../../../../../utils/common";
import { APPOINTMENT_INDICATOR_STATE_VALUE, APPOINTMENT_TOOLTIP_MESSAGE, ASSIGN_DRIVER_CTA_TEXT, BOOK_LOAD_CTA_TEXT, DEFAULT_BUTTON_COLOR, GET_QUALIFIED_BUTTON_NAME, MODULES, SHIPMENTSTATE } from "../../../../../utils/constants";
import styled from 'styled-components'
import { useSelector } from "react-redux";
import { getUserMasterData } from "../../../../../selectors/selector";
import { IUserDetails } from "../../../../../schemas/user";
import { isDispatcherRole } from "../../../../../utils/roleUtil/RoleUtil";
import { appointmentState } from "../../../../../utils/formatData";
import { ToolTip } from "../../../../../components/ToolTip/ToolTip";


const CustomButton = styled(IonButton)`
  --background: ${(props: any) =>
    props["data-testid"].split("_")[1] &&
    isDispatcherRole() &&
    props["data-testid"].split("_")[0] === BOOK_LOAD_CTA_TEXT
      ? props["data-testid"].split("_")[1]
      : DEFAULT_BUTTON_COLOR};
`;

const TopRecommendationTile = (props: TopRecommTileProps) => {
  const loadId = props && props?.loadId || "";
  const colorCode = IONICWrapper.details.getKeyValuePairs("booknow_color") || DEFAULT_BUTTON_COLOR;
  const updateduserDetails : IUserDetails  = useSelector(getUserMasterData());
  const [toolTip, setTooltip] = useState<any>(null);
  const alerticon = <IonIcon src="assets/icon/alert-app.svg" className="alert-app"
  data-test="alert-app" />
  const getActionName = (props: any): string => {
    let name: string = "";
    if (props.module == MODULES.CARRIER_ASSIGNED_MODULE){
      if(props?.shipmentState === SHIPMENTSTATE.CARRIER_ASSIGNMENT || props?.shipmentState === SHIPMENTSTATE.PENDING_DRIVER_ASSIGNMENT || props?.shipmentState === SHIPMENTSTATE.PENDING_DRIVER_UNASSIGNMENT) {
      name = ASSIGN_DRIVER_CTA_TEXT;
      }
      else name = "";
    } else if (props.module == MODULES.DRIVER_ASSIGNED_MODULE) {
      if (props.isTripStarted) {
        name = "Update";
      } else {
        name = "Start Trip";
      }
    } else if (props.module == MODULES.INTRANSIT_MODULE) {
      name = "Update";
    } else if (props.module == MODULES.RECENTLY_DELIVERED_MODULE) {
      name = "See Details";
    } else if (props.rate && props.rate.totalCharge && props.buyAllowed) {
      if(updateduserDetails && updateduserDetails.memberDetailsResponse && updateduserDetails.memberDetailsResponse.carrierInfo && 
        updateduserDetails.memberDetailsResponse.carrierInfo.carrierActiveIndicator === false)
      {
      name = IONICWrapper.details.getKeyValuePairs("get_qualified_button_title") || GET_QUALIFIED_BUTTON_NAME;
      }
      else{
        name = "Book Now";
      }
    } else {
      if(updateduserDetails && updateduserDetails.memberDetailsResponse && updateduserDetails.memberDetailsResponse.carrierInfo && 
        updateduserDetails.memberDetailsResponse.carrierInfo.carrierActiveIndicator === false && 
        updateduserDetails.memberDetailsResponse.carrierInfo.source !=="ASL")
      {
      name = IONICWrapper.details.getKeyValuePairs("get_qualified_button_title") || GET_QUALIFIED_BUTTON_NAME;
      }
      else{
      name = "Contact to Book";
      }
    }
    return name;
  };
  return (
    <div className={`recomm-tile ${props?.exclusiveLoad ? "exclusiveLoad" : ""}`}>
      {props?.exclusiveLoad && <img className="exclusive" alt="Exclusive" src="assets/images/exclusive.svg" />}
      <IonCardContent
        data-testid="onCardClick"
        onClick={() => props.onCardClick(loadId)}
        className="card-content"
      >
        <div className ="card-tooltip">
      <ToolTip icon={alerticon} message={toolTip} isActive={!!toolTip} />
      </div>
         {(appointmentState(props?.loadStop,props) === APPOINTMENT_INDICATOR_STATE_VALUE) && <IonIcon
               onClick={() => setTooltip(IONICWrapper?.details?.keys?.configuration?.AppointmentModalTooltipMessage || APPOINTMENT_TOOLTIP_MESSAGE)}
               onMouseEnter={() => setTooltip(IONICWrapper?.details?.keys?.configuration?.AppointmentModalTooltipMessage || APPOINTMENT_TOOLTIP_MESSAGE)}
               onMouseLeave={() => setTooltip(null)}
              className="appointment-time-indicator-loadCard"
              src={`assets/icon/appointment-time-indicator.svg`}
          />}
        <IonGrid className="load-grid">
          <IonRow>
            <IonCol className="card-price-col web-card-height" size="4">
              <ShipmentDetails
                {...props}
                loadId={props.loadId}
                showLoadNo={true}
              />
            </IonCol>
            <IonCol className="card-city-col" size="7">
              <IonRow>
                <LoadTileMiddle
                  {...props}
                  loadStop={props.loadDetails}
                  calculateTime={calculateTime}
                  isMyload={false}
                />
              </IonRow>
              <IonRow>
              {getActionName(props) ?<CustomButton
                  className="top-recomm-btn"
                  data-testid={`${getActionName(props)}_${colorCode}` || ""}
                  onClick={(event) => props.bookNowClick(event,props.loadId)}
                >
                  {getActionName(props)}
                </CustomButton> : <div className="empty_div"></div>
                }
              </IonRow>
            </IonCol>
            <IonCol className = "watchedLoad-icon-container">
              <IonImg
                data-testid="clickOnWatch"
                onClick={(event) => props.clickOnWatch(event)}
                src={`assets/icon/${
                  props.getWatchedLoadsData &&
                  isWatched(props.getWatchedLoadsData, props.loadId)
                    ? "watched-desktop"
                    : "watch-icon"
                }.svg`}
                className="watchedLoad-icon"
              />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </div>
  );
};
export default TopRecommendationTile;